import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'next/router'
import Loading from '~/components/Loading'

const redirectTo = '/shardlibrary'

class Index extends React.Component {
  async componentDidMount () {
    return this.props.router.replace(redirectTo)
  }

  render () {
    return <Loading />
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.authenticationReducer.user
  }
}

export default withRouter(connect(mapStateToProps)(Index))
